<div class="us-right-item-grid" [ngClass]="{'tab-header-nyusho': isNyuSho}"
    [ngStyle]="{'grid-template-columns': gridColumns, 'grid-template-rows': gridRows}">
    <div *ngFor="let header of currentHeaders; let i = index">
        <label>{{ header.headerName }}</label>
        <caremoni-switch-button
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="getXTabDpad(i)" [ydpad]="getYTabDpad(i)"
            *ngIf="header.headerName" [checked]="header.visible" (onClick)="onChangeHeaderColumns(header)">
        </caremoni-switch-button>
    </div>
</div>